import React from "react";
import "../css/returns.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Returns() {
  return (
    <div className="returns">
      <h1>Return Policy</h1>

      <p>
        We have a 30-day return policy, which means you have 30 days after
        receiving your item to request a return.
      </p>

      <p>
        To be eligible for a return, your item must be in the same condition
        that you received it, unworn or unused, with tags, and in its original
        packaging. You'll also need the receipt or proof of purchase.
      </p>

      <p>
        To start a return, you can contact us at{" "}
        <a href="mailto:west@autumncircle.website">west@autumncircle.website</a>. If your
        return is accepted, we'll send you instructions on how and where to send
        your package. Items sent back to us without first requesting a return
        will not be accepted.
      </p>

      <p>
        You can always contact us for any return question at{" "}
        <a href="mailto:west@autumncircle.website">west@autumncircle.website</a>.
      </p>

      <h2>Damages and issues</h2>
      <p>
        Please inspect your order upon reception and contact us immediately if
        the item is defective, damaged or if you receive the wrong item, so that
        we can evaluate the issue and make it right.
      </p>

      <h2>Exceptions / non-returnable items</h2>
      <p>
        Certain types of items cannot be returned, like perishable goods (such
        as food, flowers, or plants), custom products (such as bespoke, special
        orders or personalized items), and personal care goods (such as beauty
        products). We also do not accept returns for hazardous materials,
        flammable liquids, or gases. Please get in touch if you have questions
        or concerns about your specific item.
      </p>

      <p>
        Unfortunately, we cannot accept returns on sale items or gift cards.
      </p>

      <h2>Exchanges</h2>
      <p>
        The fastest way to ensure you get what you want is to return the item
        you have, and once the return is accepted, make a separate purchase for
        the new item.
      </p>

      <h2>Refunds</h2>
      <p>
        We will notify you once we've received and inspected your return, and
        let you know if the refund was approved or not. If approved, you'll be
        automatically refunded on your original payment method. Please remember
        it can take some time for your bank or credit card company to process
        and post the refund too.
      </p>

      <div className="returns__back">
        <Link onClick={toTop} to="/">
          <span className="arrow">←</span> BACK TO HOME
        </Link>
      </div>
    </div>
  );
}

export default Returns;
